import { useMemo } from 'react';

import { isAnywordMultiPromptTemplate } from 'src/data/template';
import { usePreparedMultiPromptTemplates } from 'src/services';

export const useReleasedMultiPromptTemplates = () => {
  const preparedTemplates = usePreparedMultiPromptTemplates();

  return useMemo(() => {
    return preparedTemplates.filter(isAnywordMultiPromptTemplate);
  }, [preparedTemplates]);
};
